import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BottomErrMsg } from "component/basic/popup";
import { ContentsSection, InputSection } from "component/app/items";
import { CustomSelect, TextAreaItem, BottomPopup, DatePicerRange } from "component/basic/formItems";
import { BtnBox, BtnItem } from "component/basic/btns";
import { Header } from "component/elements/header";
import moment from "moment";
import useGet from "../../api/useGet";

const Request = (props) => {
    const navigate = useNavigate();

    const [month, setMonth] = useState(moment().format("YYYY-MM"));
    const [beginDate, setBeginDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [dayOffs, setDayOffs] = useState([]);
    const [memo, setMemo] = useState('');
    const [disabledDate, setDisabledDate] = useState([]);
    const [completePopup, setCompletePopup] = useState(false);

    const [btnChk, setBtnChk] = useState(true);
    const [bottomMsgData, setBottomMsgData] = useState({chk : 0});
    const [minDate, setMinDate] = useState('');
    const [clickedOnce, setClickedOnce] = useState(false);

    const dayOffTypeApi = useGet({url: `/day/off/type?company_id=${localStorage.getItem("companyId")}`, loginType: "login"});
    const dayOffTAvailableApi = useGet({url: `/day/off/available?company_id=${localStorage.getItem("companyId")}&month=${month}`, loginType: "login"});
    const dayOffTDateAvailableApi = useGet({url: `/day/off/date/available?company_id=${localStorage.getItem("companyId")}`, loginType: "login"});
    const dayOffTDateAvailable = dayOffTDateAvailableApi?.data?.company_day_off_times;

    useEffect(() => {
        if (dayOffTypeApi) {
            setMinDate(dayOffTypeApi?.data?.enter_date);
        }
    }, [dayOffTypeApi])

    function handleSubmit() {
        let formData = new FormData();
        formData.append("company_id", localStorage.getItem("companyId"));
        for (let i = 0; i < dayOffs?.length; i++) {
            formData.append(`date[${i}]`, dayOffs[i]?.date);
            formData.append(`type[${i}]`, dayOffs[i]?.type);
            formData.append(`unpaid[${i}]`, dayOffs[i]?.optionType === 'unpaid' ? 1 : 0);
            formData.append(`official[${i}]`, dayOffs[i]?.optionType === 'official' ? 1 : 0);
        }
        formData.append("memo", memo);

        fatchSet.FatchApi({
            type: "POST",
            formDataItem: formData,
            url: "/day/off/request",
            loginType: "login",
            success: (data) => {
                setCompletePopup(true)
            },
            err: (data) => {
                if (data.data || data.alert) {
                    setBottomMsgData({
                        text : data.alert || "",
                        chk : bottomMsgData.chk + 1
                    });

                    setClickedOnce(false)
                }
            }
        })
        setClickedOnce(false)
    }

    useEffect(() => {
        const workDates = dayOffTAvailableApi?.data?.work_dates ?? [];
        const blockedDates = dayOffTAvailableApi?.data?.dates ?? [];

        if (workDates.length === 0) {
            setDisabledDate([]);
            return;
        }

        const disabledSet = new Set();

        // work_dates 기준 범위
        const sorted = [...workDates].sort();
        let cur = sorted[0];
        const end = sorted[sorted.length - 1];

        while (cur <= end) {
            if (!workDates.includes(cur)) {
                disabledSet.add(cur);
            }
            cur = moment(cur).add(1, "day").format("YYYY-MM-DD");
        }

        // dates는 무조건 비활성
        blockedDates.forEach(d => disabledSet.add(d));

        // react-datepicker용 Date 객체
        setDisabledDate(
            Array.from(disabledSet).map(d => new Date(d + "T00:00:00"))
        );
    }, [dayOffTAvailableApi]);

    useEffect(() => {
        if (beginDate !== "" && endDate !== "" && memo !== "" && generateDateRange(beginDate, endDate)
            ?.filter(selectDate =>
                !disabledDate?.some(d => {
                    if (!(d instanceof Date)) return false;

                    const ymd = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

                    return ymd === selectDate;
                })
            )
            ?.length === dayOffs?.length) {
            setBtnChk(false)
        } else {
            setBtnChk(true)
        }

    }, [beginDate, endDate, dayOffs, memo]);

    function getOptions(date) {
        const options = [];
        const dayCode = moment(date).day();

        if (dayOffTAvailableApi?.data?.work_dates?.some(item => item !== date)) {
            // 반차가 없는 경우 연차 1일 추가
            if (!(dayOffTAvailableApi?.data?.day_off_type?.[date]?.includes('morning')) && !(dayOffTAvailableApi?.data?.day_off_type?.[date]?.includes('afternoon'))) {
                options.push({id: 'day', name: '연차 (종일)'});
            }
            // 해당 날짜에 오전반차가 없으면 추가
            if (dayOffTDateAvailable?.some(item => item.type === 'morning' && item.day_code === dayCode) && !(dayOffTAvailableApi?.data?.day_off_type?.[date]?.includes('morning'))) {
                options.push({id: 'morning', name: "오전반차 | " + getTime(date, (dayOffTypeApi?.data?.company_morning_day_off_times ? dayOffTypeApi?.data?.company_morning_day_off_times : []), 'morning')});
            }
            // 해당 날짜에 오후반차 없으면 추가
            if (dayOffTDateAvailable?.some(item => item.type === 'afternoon' && item.day_code === dayCode) && !dayOffTAvailableApi?.data?.day_off_type?.[date]?.includes('afternoon')) {
                options.push({id: 'afternoon', name: "오후반차 | " + getTime(date, (dayOffTypeApi?.data?.company_afternoon_day_off_times ? dayOffTypeApi?.data?.company_afternoon_day_off_times : []), 'afternoon')});
            }
        }

        return options
    }

    const handleSubmitOnce = () => {
        if (clickedOnce) return; // 이미 눌렸으면 무시
        setClickedOnce(true);    // 눌렸음 표시
        handleSubmit();          // 원래 동작 실행
    };

    return (
        <>
            <Header
                pageBack={true}
                func={() => {
                    navigate(-1)
                }}
                headTitle="휴가 신청"
                centerTitle={true}
            />
            <ContentsSection addClass="headerContents btnContents">
                <InputSection addClass="registerSection mt-20">
                    <DatePicerRange
                        inputType="text"
                        inputTitle="날짜"
                        boxAddClass="inputGroup"
                        placeholder="날짜 선택"
                        value={beginDate + ' ~ ' + endDate}
                        disabledDate={disabledDate ? disabledDate : []}
                        monthFunc={(date) => {setMonth(moment(date).format("YYYY-MM"))}}
                        max={null}
                        minDate={minDate}
                        regexp={null}
                        func={(beginDate, endDate)=> {
                            setBeginDate(moment(beginDate).format("YYYY-MM-DD"));
                            setEndDate(moment(endDate).format("YYYY-MM-DD"));
                        }}
                    />
                    {(beginDate && endDate) && (<>
                        {generateDateRange(beginDate, endDate)
                            ?.filter(selectDate =>
                                !disabledDate?.some(d => {
                                    if (!(d instanceof Date)) return false;

                                    const ymd =
                                        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

                                    return ymd === selectDate;
                                })
                            )
                            ?.map((selectDate, selectDateKey) => (
                            <CustomSelect
                                key={selectDateKey}
                                addClass=""
                                inputTitle={`${moment(selectDate)?.format("YYYY-MM-DD")} (${moment(selectDate).format('dddd').replace('요일', '')})`}
                                placeholder="선택"
                                value={dayOffs[selectDateKey]?.type}
                                func={(name, val, subVal) => {
                                    const newDayOffs = [...dayOffs]
                                    if (!newDayOffs[selectDateKey]) {
                                        newDayOffs[selectDateKey] = {};
                                        newDayOffs[selectDateKey].date = selectDate
                                    }
                                    newDayOffs[selectDateKey].type = val
                                    setDayOffs(newDayOffs)
                                }}
                                disabled={false}
                                valKey="id"
                                nameKey="name"
                                options={getOptions(selectDate)}
                                checkboxMode="dual"
                                checkboxValue={dayOffs[selectDateKey]?.optionType ?? null}
                                checkboxFunc={(selectedKey) => {
                                    setDayOffs(prev => {
                                        const newDayOffs = [...prev];
                                        const current = newDayOffs[selectDateKey]?.optionType ?? null;

                                        newDayOffs[selectDateKey] = {
                                            ...(newDayOffs[selectDateKey] || { date: selectDate }),
                                            optionType: current === selectedKey ? null : selectedKey
                                        };

                                        return newDayOffs;
                                    });
                                }}
                                inputKey={selectDate}
                            />
                        ))}
                    </>)}
                    <TextAreaItem
                        inputTitle="메모"
                        inputName=""
                        placeholder="내용을 입력해주세요"
                        max={500}
                        maxChk={false}
                        value={memo}
                        func={(value) => setMemo(value)}
                    />
                </InputSection>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass=""
                        contents={"신청하기"}
                        disabled={btnChk || clickedOnce}
                        func={() => { handleSubmitOnce() }}
                    />
                </BtnBox>
            </ContentsSection>
            <BottomPopup
                open={completePopup}
                title="휴가 신청 완료"
                subTitle={<div>휴가 신청이 완료되었습니다.<br/>신청 결과는 관리자 승인 후 확인 가능합니다.</div>}
                btn1Text="확인"
                btn1Func={() => { navigate(`/dayoff`); }}
            />
            <BottomErrMsg
                text={bottomMsgData.text ? bottomMsgData.text : ""}
                chk={bottomMsgData.chk}
            />
        </>
    );
};

export default Request;

const generateDateRange = (start, end) => {
    let startDate = moment(start, "YYYY-MM-DD");
    const endDate = moment(end, "YYYY-MM-DD");
    const dates = [];

    while (startDate <= endDate) {
        dates.push(startDate.format('YYYY-MM-DD'));
        startDate = startDate.add(1, 'days');
    }

    return dates;
};

function getTime(date, data, type) {
    const dayCode = moment(date).format('d');

    const findTime = data.find((value) => value.day_code === Number(dayCode))
    if (findTime && (findTime?.begin_time && findTime?.end_time)) {
        const start = findTime?.begin_time.split(':')
        const end = findTime?.end_time.split(':')

        if (findTime?.begin_time > findTime?.end_time) {
            end[0] = parseInt(end[0])
            end[0] += 24
        }

        let hour = end[0] - parseInt(start[0]);
        let minute = parseInt(end[1]) - parseInt(start[1]);

        if (minute < 0) {
            hour -= 1
            if (minute === -60) {
                minute = 0
            } else {
                minute *= -1
            }
        }

        const hourDiff = hour?.toString()?.padStart(2, '0') + ':' + minute?.toString()?.padStart(2, '0')

        return findTime?.begin_time + ' ~ ' + findTime?.end_time + ' (' + hourDiff + ')'
    } else {
        if (type === 'morning') {
            return '09:00 ~ 13:00'
        } else {
            return '14:00 ~ 18:00'
        }
    }

}